import React from 'react';
import { motion } from 'framer-motion';
interface MetricCardProps {
  metric: string;
  label: string;
  sublabel: string;
  index: number;
}
function MetricCard({
  metric,
  label,
  sublabel,
  index
}: MetricCardProps) {
  return <motion.div className="glass rounded-xl overflow-hidden gold-glow" initial={{
    opacity: 0,
    scale: 0.9,
    y: 30
  }} whileInView={{
    opacity: 1,
    scale: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    delay: index * 0.15,
    duration: 0.7,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-74">
      {/* Gold shimmer line */}
      <div className="h-[2px] w-full" style={{
      background: 'linear-gradient(90deg, transparent 0%, #D4AF37 30%, #E8C547 50%, #D4AF37 70%, transparent 100%)'
    }} aria-hidden="true" data-id="element-75" />

      <div className="p-8 md:p-10" data-id="element-76">
        <p className="font-heading font-black text-4xl sm:text-5xl md:text-6xl text-ultra-gold mb-3" data-id="element-77">
          {metric}
        </p>
        <p className="font-heading text-lg md:text-xl text-white mb-1" data-id="element-78">
          {label}
        </p>
        <p className="font-body text-sm text-white/50" data-id="element-79">{sublabel}</p>
      </div>
    </motion.div>;
}
export function ResultsSection() {
  return <section className="relative min-h-screen w-full flex items-center" data-id="element-80">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 60% 40% at 50% 60%, rgba(212,175,55,0.04) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-81" />

      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-12 py-20" data-id="element-82">
        <motion.p className="font-heading text-xs md:text-sm uppercase tracking-[0.3em] text-ultra-gold mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6
      }} data-id="element-83">
          Premium Results
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-84">
          <MetricCard metric="4.2x" label="Player Retention" sublabel="vs. industry standard" index={0} data-id="element-85" />
          <MetricCard metric="€8.9M" label="Revenue Unlocked" sublabel="per operator annually" index={1} data-id="element-86" />
          <MetricCard metric="12ms" label="Personalization Latency" sublabel="real-time adaptation" index={2} data-id="element-87" />
          <MetricCard metric="99.7%" label="Prediction Accuracy" sublabel="behavioral modeling" index={3} data-id="element-88" />
        </div>
      </div>
    </section>;
}